import React from 'react'
// ##
import SizesTable from '../../modules/Size/components/SizesTable'

export default function SizePage() {
  return <SizesTable />
}
